import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { matchPath } from 'react-router';


function isLinkActive(link, pathname) {
  if (link === '/') return false;
  return link === pathname || matchPath(pathname, { path: link, exact: false, strict: false });
}

function Item(props) {
  const {
    active, children, content, icon, onClick,
    link, className, location, history,
  } = props;

  const pathname = (location && location.pathname) || null;

  let itemActive = active;
  if (!itemActive && link && pathname) {
    itemActive = isLinkActive(link, pathname);
  }

  const classes = cns(
    'sidebar__item',
    {
      'sidebar__item--active': itemActive,
    },
    className,
  );

  const handleClick = useCallback((event) => {
    if (link) {
      history && history.push(link);
    }
    onClick && onClick(event);
  }, [history, link, onClick]);

  return (
    <div
      className={classes}
      onClick={handleClick}
      role="presentation"
    >
      <div className="sidebar__item__icon">{icon}</div>
      <div className="sidebar__item__text">{content || children}</div>
    </div>
  );
}

Item.defaultProps = {
  location: {},
  history: null,
};

Item.propTypes = {
  /** Indica se l'item della sidebar è attivo */
  active: PropTypes.bool,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Testo da renderizzare */
  content: PropTypes.string,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Icona da mostrare per l'item */
  icon: PropTypes.node.isRequired,
  /** Link dell'elemento */
  link: PropTypes.string,
  /**
Callback invocata al click sull'elemento:

```
 onClick(event)
```
dove:

- `event`: evento scatenante
   */
  onClick: PropTypes.func,
  /** @ignore parametro passato da withRouter */
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  /** @ignore parametro passato da withRouter */
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Item.defaultProps = {
  active: false,
  children: null,
  className: null,
  content: null,
  link: null,
  onClick: null,
};

export default Item;
